import { twMerge } from 'tailwind-merge';

type Props = { children: React.ReactNode; className?: string };

export default function AppNavBarLayout({ children, className }: Props) {
  return (
    <header
      className={twMerge(
        'z-20 block top-0 sticky bg-background border-b',
        className,
      )}
    >
      <nav>
        <div className="relative flex justify-between py-3 px-4 md:px-8">
          {children}
        </div>
      </nav>
    </header>
  );
}
